import Form from "components/MeForm/Form";
import { cn } from "tools/ui";

const base = "grid gap-x-2 h-full";

function GridFields(props) {
  const { field, attrs } = props;
  const { level, record, ctxView, parentRec, handleButton } = attrs;
  let style = "";
  let cols = "grid-cols-2";
  let rows = "";
  let border = "";
  if (field.border === "visible") {
    border = "border border-dashed border-stone-400 px-2";
  }
  if (field.size) {
    // FIXME
    // rows = field.size[0];
    // console.log("No use este atributo field.size, va quedar en desuso!!!!");
    // console.log("A cambio use el atributo {cols} or {rows} en el ctxView");
    cols = `md:grid-cols-${field.size[1]}`;
  }
  if (field.cols) {
    cols = field.cols;
  }
  let colSpan = "grid";
  if (attrs.colSpan) {
    colSpan = attrs.colSpan;
  }
  // if (attrs.style) {
  //   style = attrs.style;
  // }
  return (
    <div
      id="grid-fields"
      key={field.id}
      className={cn(base, cols, rows, colSpan, style, border)}
    >
      {Form({
        keyName: field.name,
        ctxView: ctxView,
        webform: field.grid,
        handleButton: handleButton,
        record: record,
        parentRec: parentRec,
        level: level,
      })}
    </div>
  );
}

export default GridFields;
